<template>
  <div class="modal-card">
    <header class="modal-card-head">
      <p class="modal-card-title">Manage Destination</p>
    </header>
    <section class="modal-card-body">
        <b-field label="Name">
            <b-input
                type="text"
                v-model="destination.name"
                placeholder="e.g. Dubai"
                required>
            </b-input>
        </b-field>
    </section>
    <footer class="modal-card-foot">
      <button class="button is-primary full-width-button" :class="{'is-loading': isLoading}" @click="manageDestination">Save</button>
    </footer>
  </div>
</template>

<script>
import DestinationService from './service';

export default {
  name: 'ManageDestination',

  props: ['destination'],
  created() {
    console.log(this.destination.name);
  },
  data() {
    return {
      isLoading: false,
      name : null,
    };
  },

  methods: {
    manageDestination() {  
        this.isLoading = true;
        DestinationService.manageDestination( this.destination.docId, this.destination.name).then(() => {
     this.isLoading = false;
       this.$bus.$emit('DESTINATION_UPDATE', name);
        this.$emit('close');
        this.$toast.open({
                    message: 'Destination saved successfully',
                    type: 'is-success'
                });
                  location.reload();
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/settings/ManageDestination.vue